import * as React from 'react';

import { cn } from '../../styles/lib/utils';
import { CircularProgress } from '../CircularProgress';

type IFrameProps = Omit<React.ComponentProps<'iframe'>, 'title'> & {
  /** Names the embedded content for screen readers. */
  title: string;
  /** Classes for the wrapper that sizes the frame and centers the loading spinner. */
  className?: string;
};

/** Embedded page with a loading spinner shown until the frame finishes loading. */
function IFrame({ title, width, height, className, onLoad, ...props }: IFrameProps) {
  const [isLoading, setIsLoading] = React.useState(true);

  return (
    <div
      data-slot="iframe"
      className={cn('relative flex items-center justify-center', className)}
      style={{ width, height }}
    >
      {isLoading && (
        <div className="absolute">
          <CircularProgress indeterminate ariaLabel={`Loading ${title}`} />
        </div>
      )}
      {/* biome-ignore lint/a11y/noNoninteractiveElementInteractions: onLoad is a resource event, not a user interaction */}
      <iframe
        title={title}
        width={width}
        height={height}
        onLoad={(event) => {
          setIsLoading(false);
          onLoad?.(event);
        }}
        {...props}
      />
    </div>
  );
}

export { IFrame, type IFrameProps };
